import { render } from "./MyBetsPage.vue?vue&type=template&id=1b5c34e8"
import script from "./MyBetsPage.vue?vue&type=script&lang=js"
export * from "./MyBetsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__